export enum EMessageContentType {
  Offer = 'offer',
  ImageAsDocument = 'imagesAsDocument',
  Document = 'document',
  ImageWithText = 'imagesWithText',
  Image = 'image',
  Text = 'text',
}
